import { render } from "./applyAccess.vue?vue&type=template&id=59ae53f7"
import script from "./applyAccess.vue?vue&type=script&lang=js"
export * from "./applyAccess.vue?vue&type=script&lang=js"

import "./applyAccess.vue?vue&type=style&index=0&id=59ae53f7&lang=scss"
script.render = render

export default script